import styles from "./styles.module.css"
import { useState } from "react";

import { doc, updateDoc } from "firebase/firestore";

import { database } from "../../../services/firebase-config";

import { FaTrashRestore } from "react-icons/fa";

import Loading from "../../Loading";

export default function CategoryRestoreButton({ categoryId, updateTableData }) {
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function restoreQuestion(docId) {
        setIsLoading(true);
        const documentRef = doc(database, 'categories', docId);
        await updateDoc(documentRef, { active: true })
        setModal(false);
        setIsLoading(false);
        updateTableData();
    }


    return (<>
        <button title="Restaurar" className={styles.removeButton} onClick={() => { setModal(true) }}>
            <FaTrashRestore />
        </button>

        {modal &&
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2 className={styles.modalCard__title}>Restaurar</h2>
                    <p className={styles.modalCard__alert}>Tem certeza que deseja <strong>Restaurar</strong> este item?</p>
                    <div className={styles.modalCard__buttonsContainer}>
                        <button onClick={() => { setModal(false) }} className={styles.modalCard__closeButton}>Fechar</button>
                        <button onClick={() => { restoreQuestion(categoryId) }} className={styles.modalCard__deleteButton}>Restaurar</button>
                    </div>
                </div>
            </div>
        }

    </>);
}